import { useSignOut } from '@/hooks/useSignOut';
import { cn } from '@/lib/cn';

/** For a session the server no longer accepts: ends it here and goes to the sign-in page. */
export function SignInAgainButton({ className }: { className?: string }) {
  const { signOut, signingOut } = useSignOut();
  return (
    <button
      type="button"
      onClick={() => void signOut()}
      disabled={signingOut}
      className={cn(
        'min-h-11 min-w-11 rounded-lg bg-white px-3 text-sm font-semibold text-red-800 shadow-sm ring-1 ring-red-200 disabled:opacity-60',
        className
      )}
    >
      Sign in again
    </button>
  );
}
